import React, { useEffect, useContext, useReducer, useState } from "react";
import { dataFetchReducer } from "../../Utils/requestUtils";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment"
import ErrorBoundary from "../../Utils/ErrorBoundary";
import AuthContext from "../../../context/auth-context"
import {useHistory} from "react-router-dom"
import TimerBox from "./TimerBox/TimerBox"
import WireTransferCard from "./WireTransferCard/WireTransferCard"
import DecisionBox from "./DecisionBox/DecisionBox"
import AlertCard from "./AlertCard/AlertCard"
import ObservationCard from "./ObservationCard/ObservationCard"
import ClientCard from "./ClientCard/ClientCard"
import EnvolvedParties from "./EnvolvedParties/EnvolvedParties"
import HistoricCard from "./HistoricCard/HistoricCard"
import FraudCard from "./Fraud/FraudCard/FraudCard";
import FraudHistory from "./Fraud/FraudHistory/FraudHistory";
import FraudDialog from "./Fraud/FraudDialog/FraudDialog";
import NextTransaction from "../../Utils/NextTransaction/NextTransaction";

function WireTransfer(props){
    let history = useHistory()
    let is_fraud = false 

    let roles = useContext(AuthContext).user_data.roles
    if (!roles.includes("read_wire_transfers")){
        history.push("")
    }
    let can_write = roles.includes("update_wire_transfers")

    let { wire_transfer_key } = useParams();

    const [openDialog, setOpenDialog] = useState(false)

    const handleFraudStatus = () => {
        setOpenDialog(true)
    };

    const handleDialogClose = () => {
        setOpenDialog(false)
    };

    const [wire_transfer, dispatchWireTransfer] = useReducer(
        dataFetchReducer,
        {fetchedData: null, isLoading: true, isError: false} 
    )

    useEffect(() => {
		dispatchWireTransfer({type: "data_fetch_init"})
		const timer = setTimeout(() => {
			axios.get('/dash/wire_transfer/wire_transfer/' + wire_transfer_key).then( response => {
                dispatchWireTransfer({
                    type: "data_fetch_success",
                    payload: response.data
                })   
			}).catch(error => {
                if ((error.response || {}).status === 403) dispatchWireTransfer({type: "data_fetch_failure_403"})
                else if ((error.response || {}).status === 404) dispatchWireTransfer({type: "data_fetch_failure_404"})  
                else dispatchWireTransfer({type: "data_fetch_failure"})    
			})	
		}, 500);
		return () => {
			clearTimeout(timer)
        }
    }, [wire_transfer_key])


    if (wire_transfer.fetchedData){

        is_fraud = wire_transfer.fetchedData.fraud_status === "fraud"
        
        return (
            <div style={{minWidth:"900px", paddingBottom: "30px"}}>
                <div className="analysisCardContainer">
                    <ErrorBoundary>
                        <div style={{display:"flex", flexDirection:"column", width: "100%"}}>
                            <div style={{display:"flex", justifyContent: "space-between"}}>
                                <div className={["blueText", "titleSize"].join(" ")} style={{margin:"5px 0px"}}>
                                    Transferência {wire_transfer.fetchedData.id}
                                </div>
                                {(!is_fraud && can_write) &&
                                <div
                                    className={["button", "reproved", "normalText", "normalMediumSize"].join(" ")                            }
                                    style={{display: "flex", alignItems: "center", width: "150px", fontWeight:"600"}}
                                    onClick={handleFraudStatus}
                                >
                                    Reportar como FRAUDE
                                </div>}
                            </div>
                            <div className={["labelText", "subtitleSize"].join(" ")} style={{margin:"5px 0px"}}>
                                {moment(wire_transfer.fetchedData.wire_transfer_date).format("DD/MM/YYYY - HH:mm:ss")}
                            </div>
                        </div>
                    </ErrorBoundary>
                </div>
                <NextTransaction history={history} transaction_key={wire_transfer_key} path={"/wire-transfer"} suffix={"wire_transfer"} page_name={"Transferências"}/> 
                <div style={{display: "flex", margin: "0px 0px"}}>
                    <div style={{width: "33%"}}>
                        <div className="analysisCardContainer">
                            <ErrorBoundary>
                                <WireTransferCard wireTransfer={wire_transfer.fetchedData}/>
                            </ErrorBoundary>
                        </div>
                        <div className="analysisCardContainer">
                                <ErrorBoundary>
                                    <ClientCard wireTransfer={wire_transfer.fetchedData}/>
                                </ErrorBoundary> 
                            </div>
                    </div>
                    <div style={{width: "66%"}}>
                        <div style={{display:"flex"}}>
                            <div style={{width: "50%"}}>
                                <div className="analysisCardContainer">
                                    <ErrorBoundary>
                                        <TimerBox wireTransfer={wire_transfer.fetchedData}/>
                                    </ErrorBoundary>
                                </div>
                                <div className="analysisCardContainer">
                                    <ErrorBoundary>
                                        <DecisionBox 
                                            analysis_events={wire_transfer.fetchedData.analysis_events}
                                            analysis_status={wire_transfer.fetchedData.analysis_status}
                                        />
                                    </ErrorBoundary>
                                </div>                                
                            </div>
                            <div style={{width: "50%"}}>
                                {is_fraud && 
                                <div className="analysisCardContainer">
                                    <ErrorBoundary>
                                        <FraudCard />                                    
                                    </ErrorBoundary>   
                                </div>}
                                <div className="analysisCardContainer" style={{minHeight:"150px"}}>
                                    <ErrorBoundary>
                                        <AlertCard analysis_events={wire_transfer.fetchedData.analysis_events}/>
                                    </ErrorBoundary>   
                                </div>
                            </div>
                        </div>
                        <div className="analysisCardContainer">
                            <ErrorBoundary>
                                <EnvolvedParties wireTransfer={wire_transfer.fetchedData} />
                            </ErrorBoundary>
                        </div>
                    </div>
                </div>
                <div className="analysisCardContainer">
                    <ErrorBoundary>
                        <HistoricCard wireTransfer={wire_transfer.fetchedData}/>
                    </ErrorBoundary>			
                </div>
                {is_fraud &&
                    <div className="analysisCardContainer" >
                        <ErrorBoundary>
                            <FraudHistory wireTransfer={wire_transfer.fetchedData} can_write={can_write} dashAPIEndpointUrl={"dash/wire_transfer/wire_transfer/"}/>
                        </ErrorBoundary>   
                    </div>}
                <div className="analysisCardContainer">
                    <ErrorBoundary>
                        <ObservationCard wireTransfer={wire_transfer.fetchedData}/>
                    </ErrorBoundary>			
                </div>
                <FraudDialog
                    open={openDialog}
                    onClose={handleDialogClose}
                    wire_transfer={wire_transfer.fetchedData}
                />
            </div>
        )
    }
	else if(wire_transfer.isError){
		return (
            <div style={{height: "80vh", display:"flex"}}>
                <p className={["blueText", "titleSize"].join(" ")} style={{margin:"auto", textAlign:"center"}}>
                    {wire_transfer.errorMessage}
                </p>
            </div>
		)
	}
  
  return null;
}

export default WireTransfer;